import { IActivityBase, IActivityScheduleBase } from '../../models/activities';
import {
  IBookingBase,
  IBookingCheckinBase,
  IBookingPaymentBase,
  BookingSessionBlockBookingStatus,
} from '../../models/bookings';
import { IFeatureGroupBase } from '../../models/features';
import { ISpotBase } from '../../models/spots';
import {
  IUserAssignmentBase,
  IUserBase,
  IUserOnboardBase,
} from '../../models/users';
import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

interface IListBookingProps {
  activityId?: string;
  activityName?: string;
  activityScheduleId?: string;
  bookedDate?: string;
  featureGroups?: string[];
  hostId?: string;
  maxBookedDate?: string;
  minBookedDate?: string;
  spotName?: string;
  titularUserId?: string;
  userDocument?: string;
  userName?: string;
  userId?: string;
  sellerId?: string;
  sellerName?: string;
  sessionBlockOnly?: boolean;
  sessionBlockStatus?: BookingSessionBlockBookingStatus;
  showPaymentPendingBookingsOnly?: boolean;
  showPendingBookingsOnly?: boolean;
  noShowOnly?: boolean;
  sort?: 'activityName' | 'spotName' | 'userName' | 'bookedDate' | 'createdAt';
  order?: 'ASC' | 'DESC';
  limit?: number;
  page?: number;
}

export interface IBookingListActivity extends IActivityBase {
  spot: ISpotBase;
}

export interface IBookingListItemActivitySchedule
  extends IActivityScheduleBase {
  activity: IBookingListActivity;
}

export interface IBookingListCheckin extends IBookingCheckinBase {
  user: IUserBase;
}

interface IUserAssignment extends IUserAssignmentBase {
  featureGroup: IFeatureGroupBase;
}

interface IBookingListItemUser extends IUserBase {
  onboards: IUserOnboardBase[];
  userAssignments: IUserAssignment[];
}

export interface IBookingListItem extends IBookingBase {
  activitySchedule: IBookingListItemActivitySchedule;
  checkins: IBookingListCheckin[];
  payment?: IBookingPaymentBase;
  user: IBookingListItemUser;
}

export type IBookingList = IListResponse<IBookingListItem>;

export const listBookingsService = async (
  filters?: IListBookingProps,
): Promise<IBookingList> => {
  const params =
    filters && Object.keys(filters).length !== 0
      ? {
          activityId: filters.activityId || undefined,
          activityName: filters.activityName || undefined,
          activityScheduleId: filters.activityScheduleId || undefined,
          bookedDate: filters.bookedDate || undefined,
          maxBookedDate: filters.maxBookedDate || undefined,
          minBookedDate: filters.minBookedDate || undefined,
          featureGroups: filters.featureGroups,
          hostId: filters.hostId || undefined,
          spotName: filters.spotName || undefined,
          titularUserId: filters.titularUserId || undefined,
          userDocument: filters.userDocument || undefined,
          userName: filters.userName || undefined,
          userId: filters.userId || undefined,
          sellerId: filters.sellerId || undefined,
          sellerName: filters.sellerName || undefined,
          sessionBlockOnly: filters.sessionBlockOnly,
          sessionBlockStatus: filters.sessionBlockStatus,
          showPaymentPendingBookingsOnly:
            filters.showPaymentPendingBookingsOnly,
          showPendingBookingsOnly: filters.showPendingBookingsOnly,
          noShowOnly: filters.noShowOnly,
          sort: filters.sort,
          order: filters.order,
          limit: filters.limit,
          page: filters.page,
        }
      : undefined;

  const { data } = await jhsfBookingsApi.get<IBookingList>('/bookings', {
    params,
  });

  return data;
};
